import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import "../../CSS/Education.css";

import EducationStepper from "./EducationStepper";

import { AppContext } from "../Context.js";
export default function Education({ id }) {
  const [itemSnapped] = useContext(AppContext);
  return (
    <React.Fragment>
      <div
        className={itemSnapped === "Education" ? "vanish" : "education"}
        id={id}
      >
        <Grid container spacing={0} className="bge">
          <Grid item md={12} sm={12} xs={12}>
            <div className="titleDiv">
              <h1 className="sectionsTitle">Education</h1>
            </div>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <EducationStepper />
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}
